import { useI18n } from "hooks/i18n/i18n";
import { convertBrToLineBreakCode } from "utility/convertBrTo";

import type { Props } from "./props";

type Input = Props;

export const useThis = (input: Input) => {
  const { amount, title } = input;

  const { t } = useI18n();
  const sanitizedTitle = title.trim()
    ? convertBrToLineBreakCode(title)
    : "商品画像";
  const formattedAmount = Number.isFinite(amount)
    ? amount.toLocaleString()
    : "0";
  const tax = t("ui.goodsCard.tax");

  return {
    formattedAmount,
    sanitizedTitle,
    tax,
  };
};
